/*
  Regalo automático Cyber Copec.

  El descuento CYBERCOPEC ("Compra X y llévate Y") descuenta un aromatizador de auto
  cuando el cliente gasta $30.000, pero Shopify NO lo agrega al carro: si el cliente
  no lo puso a mano, se va sin el regalo y sin enterarse. Esto lo agrega por él.

  Cómo decide: no replicamos la configuración del descuento (colecciones, mínimo,
  exclusiones). Agregamos el regalo y le preguntamos a Shopify si lo dejó en $0.
  Si no lo dejó gratis, el carro no calificaba y lo sacamos. Así el día que el equipo
  cambie las colecciones o el monto en el Admin, esto sigue correcto solo.

  Condición de entrada: el código tiene que estar aplicado en la sesión, o sea que el
  cliente llegó por spotessence.cl/discount/CYBERCOPEC. Sin código no se agrega nada,
  para que la venta atribuida a COPEC sea de verdad de COPEC.

  Configuración: snippets/spot-copec-regalo.liquid (window.SpotCopecConfig).
  Verificación: scripts/verify-copec-gift.sh
*/
(function () {
  var config = window.SpotCopecConfig || {};
  var CODE = String(config.code || '').trim().toUpperCase();
  var VARIANT = config.giftVariantId;
  var PROP_KEY = config.propertyKey || 'Regalo';
  var PROP_VALUE = config.propertyValue || 'Cyber Copec';

  if (!CODE || !VARIANT) { return; }

  var busy = false;
  // ponytail: memo por subtotal, evita reintentar el mismo carro que ya no calificó.
  // Si el cliente cambia productos dejando el subtotal igual, recién se reevalúa en el
  // siguiente cambio que lo suba. Si algún día molesta, comparar el carro completo.
  var lastTrySubtotal = -1;

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function hasCode(cart) {
    return (cart.discount_codes || []).some(function (d) {
      return String(d.code || '').trim().toUpperCase() === CODE;
    });
  }

  function isGift(item) {
    return !!(item.properties && item.properties[PROP_KEY] === PROP_VALUE);
  }

  function giftLine(cart) {
    return (cart.items || []).filter(isGift)[0];
  }

  // Subtotal sin el regalo y a precio de lista: memo estable aunque el descuento
  // entre y salga.
  function baseSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return isGift(item) ? sum : sum + item.original_line_price;
    }, 0);
  }

  // POST fuera de window.fetch a propósito: theme.liquid intercepta /cart/add.js y
  // dispara add_to_cart a GA4 y Meta. El regalo no es una acción del cliente y vale
  // $0, contarlo ensucia el funnel.
  function post(url, body) {
    return new Promise(function (resolve) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () { resolve(xhr.status >= 200 && xhr.status < 300); };
      xhr.onerror = function () { resolve(false); };
      xhr.send(JSON.stringify(body));
    });
  }

  function addGift() {
    var properties = {};
    properties[PROP_KEY] = PROP_VALUE;
    return post('/cart/add.js', { items: [{ id: VARIANT, quantity: 1, properties: properties }] });
  }

  function removeLine(key) {
    return post('/cart/change.js', { id: key, quantity: 0 });
  }

  function refreshUI() {
    if (typeof window.refreshCartContents === 'function') {
      return window.refreshCartContents({ ok: true });
    }
    return null;
  }

  function reconcile() {
    if (busy) { return Promise.resolve(); }
    busy = true;

    return getCart().then(function (cart) {
      var gift = giftLine(cart);

      if (!hasCode(cart)) {
        lastTrySubtotal = -1;
        return gift ? removeLine(gift.key).then(refreshUI) : null;
      }

      if (gift) {
        // Shopify ya decidió: si la línea no quedó gratis, el carro dejó de calificar.
        if (gift.total_discount > 0) { return null; }
        lastTrySubtotal = baseSubtotal(cart);
        return removeLine(gift.key).then(refreshUI);
      }

      // El cliente ya puso un aromatizador por su cuenta y el descuento se lo comió:
      // no corresponde un segundo regalo.
      var alreadyFree = (cart.items || []).some(function (item) { return item.total_discount > 0; });
      if (alreadyFree) { return null; }

      var subtotal = baseSubtotal(cart);
      if (subtotal <= lastTrySubtotal) { return null; }
      lastTrySubtotal = subtotal;

      return addGift().then(function (ok) {
        if (!ok) { return null; } // sin stock o variante caída: no molestamos al cliente
        return getCart().then(function (after) {
          var line = giftLine(after);
          if (!line) { return null; }
          // No calificaba: deshacemos sin repintar, el cliente nunca lo vio.
          if (line.total_discount <= 0) { return removeLine(line.key); }
          return refreshUI();
        });
      });
    }).catch(function () {
      /* silent: el regalo nunca puede romper el carro */
    }).then(function () {
      busy = false;
    });
  }

  window.spotCopecReconcile = reconcile; // usado por la verificación
  window.addEventListener('updated.ecomify.cart', reconcile);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
